module.exports = __webpack_public_path__ + "f0109a4d5b4de8ece863f8ee96da81c8.png";